<template>
  <el-card v-if="publicData.$ready && publicData.bugbounty" class="mt-4 p-2">
    <h3>Bug bounty result</h3>
    <ul style="font-size: 200%" class="pl-2">
      <li v-for="(amount, bounty) in publicData.bugbounty" :key="bounty">
        {{amount}}&times;{{bounty}}
      </li>
      <div>&Sigma; {{Object.values(publicData.bugbounty).reduce((v,a) => v + a, 0)}}</div>
    </ul>
    <h3>Trophies</h3>
    <div style="display: flex; flex-wrap: wrap;">
      <div
        v-for="trophyrule in TRROPHY_RULES"
        :key="trophyrule.symbol"
        :class="{
          'card' : true,
          'trophy': true,
          'trophy--earned': trophyrule.rule(publicData.bugbounty),
        }">
        <el-tooltip
          :content="trophyrule.criteria"
          placement="top"
          effect="light">
          <span style="font-size: 300%">{{trophyrule.symbol}}</span>
        </el-tooltip>
        <strong>{{trophyrule.description}}</strong>
      </div>
    </div>
    <!--
    <a href="#" @click="$models.userPublic.update( $models.user.defaultUserId, {bugbounty: {}} )">reset</a>
     -->
  </el-card>
</template>

<script>

const TRROPHY_RULES = [
  {
    symbol: '👶',
    description: 'Beginner',
    criteria: 'Get any bug',
    rule: (bountylist) => {
      return bountylist['🐛'] >= 1 ||
             bountylist['🐞'] >= 1 ||
             bountylist['🐜'] >= 1 ||
             bountylist['🕷️'] >= 1 ||
             bountylist['🦋'] >= 1;
    }
  },
  {
    symbol: '🔍',
    description: 'Butterfly catcher',
    criteria: 'Get 5 x 🦋',
    rule: (bountylist) => {
      return bountylist['🦋'] >= 5
    }
  },
  {
    symbol: '💪',
    description: 'Bugs contain protein',
    criteria: 'Get 5 x 🐛',
    rule: (bountylist) => {
      return bountylist['🐛'] >= 5
    }
  },
  {
    symbol: '👨‍🔧',
    description: 'Janitor',
    criteria: '🐞 x 7',
    rule: (bountylist) => {
      return bountylist['🐞'] >= 7
    }
  },
  {
    symbol: '👨‍🎓',
    description: 'Ph.D. in Entomology',
    criteria: 'Get 🐛 + 🐞 + 🐜 + 🕷️ + 🦋',
    rule: (bountylist) => {
      return bountylist['🐛'] >= 1 &&
             bountylist['🐞'] >= 1 &&
             bountylist['🐜'] >= 1 &&
             bountylist['🕷️'] >= 1 &&
             bountylist['🦋'] >= 1;
    }
  },
  {
    symbol: '🕵️',
    description: 'Pest control first job',
    criteria: 'Get 10 of every bug',
    rule: (bountylist) => {
      return ['🐛', '🐞', '🐜', '🕷️', '🦋'].every(s => bountylist[s] >= 5)
    }
  },
  {
    symbol: '📜',
    description: 'Pest control business license',
    criteria: 'Get 5 of every bug',
    rule: (bountylist) => {
      return ['🐛', '🐞', '🐜', '🕷️', '🦋'].every(s => bountylist[s] >= 10)
    }
  },
  {
    symbol: '👩‍🏭',
    description: 'Exterminator',
    criteria: 'Get 10x🐛 + 5x🐞 + 3x🐜 + 2x🕷️ + 1x🦋',
    rule: (bountylist) => {
      return bountylist['🐛'] >= 10 &&
             bountylist['🐞'] >= 5 &&
             bountylist['🐜'] >= 3 &&
             bountylist['🕷️'] >= 2 &&
             bountylist['🦋'] >= 1;
    }
  },
  {
    symbol: '☠️',
    description: 'Bug killer',
    criteria: 'Get 25 bugs in total',
    rule: (bountylist) => {
      return ['🐛', '🐞', '🐜', '🕷️', '🦋'].reduce(s => bountylist[s], 0) >= 25
    }
  },
  {
    symbol: '👹',
    description: 'Ogre the bug eater',
    criteria: 'Get 50 bugs in total',
    rule: (bountylist) => {
      return ['🐛', '🐞', '🐜', '🕷️', '🦋'].reduce(s => bountylist[s], 0) >= 50
    }
  },
  {
    symbol: '🦕',
    description: 'Mass extiction',
    criteria: 'Get 100 bugs in total',
    rule: (bountylist) => {
      return ['🐛', '🐞', '🐜', '🕷️', '🦋'].reduce(s => bountylist[s], 0) >= 100
    }
  }
]

export default {
  props: {
    contactId: { required: true },
  },
  data() {
    return {
      TRROPHY_RULES,
    };
  },
  computed: {
    publicData() {
      return this.$models.userPublic.subscribeNode( this.contactId )
    },
  },
  methods: {
  }
};
</script>

<style scoped>
.trophy {
  cursor: default;
  padding-top: 2em;
  border-radius: 50%;
  text-align: center;
  width: 150px;
  height: 150px;
  opacity: 0.3;
  margin-right: 1em;
}
.trophy--earned {
  opacity: 1;
  background-color: #ffd70066;
}
.trophy--earned span::after {
  content: "🏆";
}
</style>
